import React, {useEffect, useState} from 'react'
import MDBox from "../../../components/MDBox";
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import LocalStorage from "../../../utils/LocalStorage";
import {getMultiAddressList, Logout, onErrorAlert, onSuccessAlert, removeMultiAddress} from "../../../actions";
import {noop} from "lodash";
import {zhCN, enUS} from '@mui/x-data-grid/locales';
import {MuiDataGrid} from "../../../components/MuiDatagrid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from '@mui/icons-material/Edit';
import MDButton from "../../../components/MDButton";
import AddIcon from '@mui/icons-material/Add';
import MDTypography from "../../../components/MDTypography";
import MultiddressAdd from "./MultiaddressAdd";
import BeenhereIcon from '@mui/icons-material/Beenhere';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import PaperComponent from "../../../components/MuiDraggableDialog";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";

const MultiAddress = () => {
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(false)
    const [height, setHeight] = useState(0)
    const [pageSize, setPageSize] = useState(15)
    const [pageNum, setPageNum] = useState(1)
    const nav = useNavigate()
    const dispatch = useDispatch()
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const fixedNavbar = useSelector(state => state?.common?.fixedNavbar,(prev, next) => prev === next)
    const list = useSelector(state => state?.auth?.multiAddressList,(prev, next) => prev === next);
    const totalRows = useSelector(state => state?.auth?.multiAddressListTotal,(prev, next) => prev === next);
    const [isAddressOpen,setIsAddressOpen] = useState(false)
    const [currentAddress,setCurrentAddress] = useState(null)
    const [addresses,setAddresses] = useState([])
    const [mode,setMode] = useState('Add')//for address
    const [isAlertOpen, setIsAlertOpen] = useState(false)
    const [selectDeleteRow,setSelectDeleteRow] = useState(null)


    const onSubmit = (selectDeleteRow)=>{
        dispatch(removeMultiAddress({
            addressLineNo: selectDeleteRow.addressLineNo ,
            userName: selectDeleteRow.ownerName
        },(msg)=>{
            dispatch(onSuccessAlert(t(msg)))
            let formData = {}
            if (saveFormData()) {
                formData = saveFormData()
            } else {
                return nav('/')
            }
            const axiosPost = async () => {
                setIsAlertOpen(false)
                setLoading(true)
                await dispatch(getMultiAddressList(formData, onSearchSuccess, onError))
            }
            axiosPost().then()
        },onError))
    }


    const columns = [
        {
            field: 'name',
            headerName: t("AccountPage.Name"),
            width: 180,
            renderCell: (params) => (
                <Grid sx={{display:"flex",justifyContent: "space-between",alignItems: "center"}}
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid > {params?.value}
                        </Grid>

                    </Tooltip >
                    <Tooltip title={"Default"}>
                        <Grid sx={{display:"flex",justifyContent: "space-between",alignItems: "center"}}>
                            {params?.row?.isDefault === 'Y' &&<BeenhereIcon fontSize={"medium"} color="success"/>}
                        </Grid>

                    </Tooltip>
                </Grid>
            )
        },
        // {
        //     field: 'isDefault',
        //     headerName: 'Is Default',
        //     width: 80,
        //     renderCell: (params) => (
        //         <Grid>
        //             <Tooltip>
        //                 <Grid>{params?.value === 'Y'?
        //                         <BeenhereIcon color="success"/>
        //                     :
        //                     <BeenhereIcon/>
        //                 }</Grid>
        //             </Tooltip>
        //
        //         </Grid>
        //     )
        // },
        {
            field: 'address1',
            headerName:t("AccountPage.Address 1") ,
            width: 150,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'zipcode',
            headerName: t("AccountPage.Postal Code"),
            width: 100,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'city',
            headerName: t("AccountPage.City"),
            width: 120,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'province',
            headerName: t("AccountPage.State/Province"),
            width: 120,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'country',
            headerName: t("AccountPage.Country"),
            width: 70,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'phone',
            headerName: t("AccountPage.Phone"),
            width: 120,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'addressLineNo',
            headerName: t("AccountPage.Address Line No"),
            width: 110,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'address2',
            headerName: t("AccountPage.Address 2"),
            width: 150,
            renderCell: (params) => (
                <Grid
                    onDoubleClick={() => handleCellDoubleClick(params)}>
                    <Tooltip title={params?.value}>
                        <Grid>{params?.value}</Grid>
                    </Tooltip>

                </Grid>
            )
        },
        {
            field: 'operation',
            headerName: t("AccountPage.Operation"),
            width: 100,
            renderCell: (params) => (
                <div>
                    <Tooltip title={'Edit'}>
                        <IconButton color="primary"
                                    disabled={!checkPermission(PERMISSION_DICT.AccountMultiAddressModify)}
                                    onClick={()=>{
                                        setMode('Edit')
                                        setCurrentAddress(params?.row)
                                        setIsAddressOpen(true)
                                    }}
                        >
                            <EditIcon/>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={'Delete'}>
                        <IconButton color="error"
                                    disabled={!checkPermission(PERMISSION_DICT.AccountMultiAddressDelete)}
                                    onClick={()=>{
                            setSelectDeleteRow(params?.row)
                            setIsAlertOpen(true)
                        }}>
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                </div>
            )
        },

    ]


    const onSearchSuccess = (data) => {
        setLoading(false)

    }


    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        setLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }


    const saveFormData = () => {
        let formData = {}
        formData.pageNum = pageNum
        formData.pageSize = pageSize
        formData.language = languageSelect
        if (LocalStorage.getItem('username')) {
            formData.userName = LocalStorage.getItem('username')
        } else {
            return null
        }

        return formData
    }

    function handlePaginationChange(data) {
        setPageNum(() => data.page + 1)
        setPageSize(() => data.pageSize)
    }

    const handleCellDoubleClick = (params) => {
        const textToCopy = params?.value;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };


    useEffect(() => {

        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }

        const axiosPost = async () => {

            setLoading(true)
            await dispatch(getMultiAddressList(formData, onSearchSuccess, onError))
        }
        checkPermission(PERMISSION_DICT.AccountMultiAddressList) && axiosPost().then()

    }, [pageSize, pageNum, languageSelect]);

    useEffect(() => {
        if (fixedNavbar) {
            setHeight(document.getElementById('appBar')?.clientHeight + 10)
        } else {
            setHeight(0)
        }

    }, [fixedNavbar]);


    return (<React.Fragment>
            <MDBox pb={1}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        // marginLeft: '40px',
                        // marginRight: '40px',
                        alignItems: 'center',
                        marginBottom: '20px',
                        flexWrap: 'wrap',
                    }}
                >
                    <div>
                        <MDTypography variant="h6" fontWeight="medium">
                            {t("AccountPage.Multiple-Address information")}
                        </MDTypography>
                    </div>
                    <div>
                        <MDButton
                            disabled={!checkPermission(PERMISSION_DICT.AccountMultiAddressAdd)}
                            variant="gradient" color="info" size="small"
                                  startIcon={<AddIcon sx={{fontSize: "40px"}}/>}
                                  onClick={() => setIsAddressOpen(true)}
                        >
                            {t("AccountPage.add new address")}
                        </MDButton>
                    </div>
                </div>
                <Grid pl={{md:1,sx:1}} pr={{md:1,sx:1}}>
                    <MuiDataGrid
                        rowHeight={40}
                        sx={{
                            '& .MuiDataGrid-main': {
                                overflow: "unset"
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                position: "sticky",
                                top: height,
                                zIndex: '1100'
                            },
                        }}
                        localeText={languageSelect === 'zh' ? zhCN.components.MuiDataGrid.defaultProps.localeText : enUS.components.MuiDataGrid.defaultProps.localeText}
                        disableRowSelectionOnClick
                        disableColumnMenu={true}
                        disableColumnFilter={true}
                        disableColumnSorting={true}
                        getRowId={(row) => row?.id}
                        rowCount={totalRows}
                        autoHeight
                        loading={loading}
                        rows={list}
                        columns={columns}
                        pageSizeOptions={[15, 50, 100]}
                        initialState={{
                            pagination: {paginationModel: {page: 0, pageSize: 15}},
                        }}
                        paginationMode={"server"}
                        onPaginationModelChange={
                            handlePaginationChange
                        }
                    />
                </Grid>
            </MDBox>
            <MultiddressAdd
                isAddressOpen={isAddressOpen}
                setIsAddressOpen={setIsAddressOpen}
                addresses={addresses}
                setAddresses={setAddresses}
                currentAddress={currentAddress}
                setCurrentAddress={setCurrentAddress}
                setMode={setMode}
                mode={mode}
                pageLoading={loading} setPageLoading={setLoading}
                pageFormData={saveFormData()}
            />
            <Dialog
                open={isAlertOpen}
                onClose={() => {
                    setIsAlertOpen(false)
                }}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={'sm'}
            >
                <DialogTitle id="draggable-dialog-title" style={{ cursor: 'move' }}>
                    <div>{t("Are you sure?")}</div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {`Do you really want to delete The Address:`}
                        <span style={{
                            color: 'red',
                            padding: '10px',
                            fontWeight: 'bold'
                        }}>{selectDeleteRow?.address1}</span>
                        ? {t('This process cannot be undone')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => setIsAlertOpen(false)}>Disagree</MDButton>
                    <MDButton onClick={()=>{onSubmit(selectDeleteRow)}} autoFocus sx={{ color: 'red' }} variant='outlined'>
                        Agree
                    </MDButton>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default MultiAddress